import * as React from 'react';
import { MY_ACTIVITY_PAGE } from 'constants/pages';
import { NotificationActionTypesEnum } from 'types/generated/client';
import { getBookingFailureReason } from 'utils/shared/partnerBooking/bookingFailureReason';
import { formatInVenueZone } from 'utils/shared/time/formatInVenueZone';
import { formatVenueTimeRange } from 'utils/shared/time/formatVenueTimeRange';
import Link from 'components/Link';
import classNames from 'styles/utils/classNames';
import CardNotification from './CardNotification';
import { CourtBookingActionType, CourtBookingNotificationProps } from '../types';

const VARIANTS: Record<
  CourtBookingActionType,
  { pill: string; pillClassName: string; message: (failureReason?: string | null) => string }
> = {
  [NotificationActionTypesEnum.CourtBookingConfirmed]: {
    pill: 'Court Booked',
    pillClassName: 'bg-color-brand-primary text-color-success-background',
    message: () => 'Your court is booked',
  },
  [NotificationActionTypesEnum.CourtBookingFailed]: {
    pill: 'Booking Failed',
    pillClassName: 'bg-color-bg-lightmode-error text-color-text-lightmode-error',
    message: (failureReason) =>
      `We couldn't book your court. ${getBookingFailureReason(
        failureReason,
      )} Your card was not charged.`,
  },
};

export default function CourtBookingNotification({
  status,
  order,
  actionType,
}: CourtBookingNotificationProps) {
  const [initialStatus] = React.useState(status);

  if (!order) {
    return null;
  }

  const variant = VARIANTS[actionType];

  return (
    <Link href={MY_ACTIVITY_PAGE} className="block">
      <CardNotification status={initialStatus}>
        <div className="p-2">
          <div className="flex items-center justify-between">
            <div className="text-xs font-semibold leading-5">{order.venue.title}</div>
            <div className={classNames('rounded-xl px-2 text-xs leading-5', variant.pillClassName)}>
              {variant.pill}
            </div>
          </div>
          <div className="mt-1 text-xs leading-5">{variant.message(order.failureReason)}</div>
          <div className="mt-1 flex items-center text-xs">
            <div className="mr-4 text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
              {formatVenueTimeRange(order.startAt, order.endAt, order.timezone)}
            </div>
            <div className="text-color-brand-primary">
              {formatInVenueZone(order.startAt, 'MMM d', order.timezone)}
            </div>
          </div>
        </div>
      </CardNotification>
    </Link>
  );
}
